var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgMobile(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M20.838 4H10.762C9.791 4 9 4.79 9 5.762v20.476C9 27.209 9.79 28 10.762 28h10.076c.972 0 1.762-.79 1.762-1.762V5.762C22.6 4.791 21.81 4 20.838 4zM9.8 7.2h12v15.2h-12V7.2zm.962-2.4h10.076c.53 0 .962.432.962.962V6.4h-12v-.638c0-.53.432-.962.962-.962zm10.076 22.4H10.762a.963.963 0 01-.962-.962V23.2h12v3.038c0 .53-.431.962-.962.962z"
  }), React.createElement("path", {
    d: "M15.8 23.6c-.882 0-1.6.718-1.6 1.6 0 .882.718 1.6 1.6 1.6.883 0 1.6-.718 1.6-1.6 0-.882-.717-1.6-1.6-1.6zm0 2.4a.8.8 0 11.002-1.602A.8.8 0 0115.8 26zM14.2 6h1.6a.4.4 0 100-.8h-1.6a.4.4 0 100 .8zM17 6h.4a.4.4 0 100-.8H17a.4.4 0 100 .8z"
  })));
}

export default SvgMobile;